import React from 'react';
import classNames from 'classnames';
import { SectionProps } from '../../utils/SectionProps';
import Button from '../elements/Button';
import Image from '../elements/Image';

const propTypes = {
  ...SectionProps.types
}

const defaultProps = {
  ...SectionProps.defaults
}

class HeroFull extends React.Component {

  render() {
    const {
      className,
      topOuterDivider,
      bottomOuterDivider,      
      topDivider,
      bottomDivider,
      hasBgColor,
      invertColor,
      ...props
    } = this.props;

    const outerClasses = classNames(
      'hero section center-content',
      topOuterDivider && 'has-top-divider',
      bottomOuterDivider && 'has-bottom-divider',
      hasBgColor && 'has-bg-color',
      invertColor && 'invert-color',
      className
    );

    const innerClasses = classNames(
      'hero-inner section-inner',
      topDivider && 'has-top-divider',
      bottomDivider && 'has-bottom-divider'
    );

    return (
      <section
        {...props}
        className={outerClasses}
      >
        <div className="container-sm">
          <div className={innerClasses}>
            <div className="hero-content">
              <h1 className="mt-0 mb-16 reveal-from-top" data-reveal-delay="300">
                La livraison est entre vos mains
              </h1>
              <div className="container-xs">
                <p className="mt-0 mb-32 reveal-from-top" data-reveal-delay="400">
                  Obtenez la flexibilité, la visibilité et les données nécessaires pour vous mettre en relation avec des livreurs. Devenez partenaire dès aujourd'hui.
                </p>
                <div className="reveal-from-top" data-reveal-delay="500">
                  <Button tag="a" color="primary" href="https://app.gorider.co/" wideMobile>
                    Lancez une livraison
                  </Button>
                </div>
              </div>
            </div>
            <div className="hero-figure illustration-element-01 reveal-from-top" data-reveal-delay="500">
              <Image
                src={require('./../../assets/images/hero-media.png')}
                width={950}
                height={525}
                alt="Hero" />
            </div>
          </div>
        </div>
      </section>
    );
  }
}


HeroFull.propTypes = propTypes;
HeroFull.defaultProps = defaultProps;

export default HeroFull;